// utils/cn.ts - Utility for merging Tailwind classes
import { clsx, type ClassValue } from 'clsx';

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}

// You'll need to install clsx: npm install clsx
// This is a lightweight utility for conditionally joining classNames